function data() {
	return {
		params: {
			customerId: null,
			page: 1,
			limit: 15,
			search: null,
		},
		table: {
			lastPage: 1,
			rows: [],
			itemTotal: null,
		},
		loadingAcc: false,
		periods: null,
	};
}

function goTo(name, options) {
	this.$router.push({ name, ...options });
}

function getImageUrl(imageUrl) {
	return `${this.$imageUrl}/${imageUrl}`;
}

async function loadData(url) {
	try {
		const { data: records, headers } = await this.$http.get(url, { params: this.params });
		this.periods = records;
		this.table.lastPage = Number(headers['x-last-page']);
		this.table.itemTotal = Number(headers['x-quantity']);
		this.table.rows = records.map((record) => {
			const newRecord = { ...record };
			newRecord.isSelected = false;
			return newRecord;
		});
		return { records, headers };
	} catch (err) {
		console.log('erroooooooo::: ', err);
		if (err.status === 400) {
			if (err.data.message === 'ACCOUNTANT_WITHOUT_CUSTOMERS') {
				this.showNotification('La cuenta no tiene clientes', 'warning');
			} else if (err.data.message === 'COM_ACCOUNTING_PLAN_ACTIVE_NOT_FOUND') {
				this.showGenericError('No se ha encontrado un plan de cuentas activo para la empresa seleeccionada.');
			}
		}
	} finally {
		this.loadingAcc = false;
	}
	return {};
}

function onSearch(value, url) {
	this.params.search = value || null;
	this.params.page = 1;
	this.loadData(url);
}

function replaceString(word, selectionStart, newWord) {
	if (word) {
		return word.slice(0, selectionStart) + newWord + word.slice(selectionStart + 0);
	}
	return newWord;
}

function showNotification(text, color = 'success') {
	this.$store.dispatch('showSnackBar', { text, color });
}

function showGenericError(text = 'Ups, ocurrió algún problema') {
	this.showNotification(text, 'error');
}

function showRow(columns, columnId) {
	const column = columns.find(h => h.id === columnId);
	return column.visible;
}

function token() {
	return this.$store.getters['user/token'];
}

function stopClick() {
	return false;
}

function setLocalData(key, dataInfo) {
	return localStorage.setItem(key, JSON.stringify(dataInfo));
}

function labelsByCountry() {
	const user = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const company = user.company;
	const country = company.country;
	const geopositionPer = { lat: -12.0727971, lng: -77.0452889 };
	const geopositionEcu = { lat: -0.1764507, lng: -78.47527600000001 };
	const defaultCountry = {
		id: 1,
		name: 'Perú',
		code: 'PER',
		geoposition: geopositionPer,
	};
	if (country) {
		return {
			id: country.id,
			code: country.countryCode,
			geoposition: country.countryCode === 'PER' ? geopositionPer : geopositionEcu,
			name: country.name,
		};
	}
	return defaultCountry;
}

function isEcuador() {
	return this.labelsByCountry.id === 2;
}

function isPeru() {
	return this.labelsByCountry.id === 1;
}

const mixin = {
	data,
	computed: {
		token,
		labelsByCountry,
		isEcuador,
		isPeru,
	},
	methods: {
		getImageUrl,
		goTo,
		loadData,
		onSearch,
		replaceString,
		setLocalData,
		showGenericError,
		showNotification,
		showRow,
		stopClick,
	},
};

export default mixin;



// WEBPACK FOOTER //
// ./src/mixins/global.js